export const TYPE_LIST = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '年报',
    value: 1,
  },
  {
    label: '季报',
    value: 2,
  },
  {
    label: '月报',
    value: 3,
  },
  {
    label: '安华工商大数',
    value: 4,
  },
  {
    label: '安华详财',
    value: 5,
  },
]

export const BATCH_UNUSUAL = {
  assetLiabilityRatio: {
    label: '总资产负债率',
    outerWidth: "120px",
  },
  netWorth: {
    label: '净资产',
  },
  operatingFunds: {
    label: '运营资金',
  },
  retainedEarnings: {
    label: '留存收益/总资产',
  },
  currentLiabilities: {
    label: '流动负债/净资产',
  },
  quickFrozenRatio: {
    label: '速冻比率',
  },  
  netProfitRatio: {
    label: '净利润率',
  },
  operatingIncome: {
    label: '主营业收入/总资产',
  },
  netWorthProfitRatio: {
    label: '净资产收益率',
  },
  accountsReceiveDays: {
    label: '应收账款周转天数',
  },
  accountsPayDays: {
    label: '应付账款周转天数',
  },
  inventoryTurnoverDays: {
    label: '库存周转天数',
  },
  salesGrowthRate: {
    label: '销售增长率',
  },
}

export const BALANCE_KEY_TITLE_OBJ = {
  c_52_d: { title: '资产总计', bold: true, paddingLeft: '0px' },
  c_22_d: { title: '流动资产合计', bold: true, paddingLeft: '20px' },
  c_5_d: { title: '货币资金' },
  c_6_d: { title: '短期投资' },
  c_7_d: { title: '交易性金融资产' },
  c_8_d: { title: '应收票据' },
  c_9_d: { title: '应收账款' },
  c_10_d: { title: '预付款项' },
  c_11_d: { title: '应收利息' },
  c_12_d: { title: '应收股利' },
  c_13_d: { title: '应收补贴款' },
  c_14_d: { title: '其他应收款' },
  c_15_d: { title: '存 货' },
  c_16_d: { title: '待摊费用' },
  c_17_d: { title: '一年内到期的非流动资产' },
  c_18_d: { title: '其他流动资产' },
  c_30_d: { title: '长期投资合计', bold: true, paddingLeft: '20px' },
  c_24_d: { title: '可供出售金融资产' },
  c_25_d: { title: '持有至到期投资' },
  c_26_d: { title: '长期应收款' },
  c_27_d: { title: '长期股权投资' },
  c_28_d: { title: '长期债权投资' },
  c_29_d: { title: '投资性房产' },
  c_35_d: { title: '固定资产净额合计', bold: true, paddingLeft: '20px' },
  c_32_d: { title: '固定资产原价' },
  c_33_d: { title: '减：累计折旧' },
  c_34_d: { title: '减：固定资产减值准备' },
  c_42_d: { title: '其他固定资产合计', bold: true, paddingLeft: '20px' },
  c_37_d: { title: '在建工程' },
  c_38_d: { title: '工程物资' },
  c_39_d: { title: '固定资产清理' },
  c_40_d: { title: '生产性生物资产' },
  c_41_d: { title: '油气资产' },
  c_51_d: { title: '无形资产及其他资产合计', bold: true, paddingLeft: '20px' },
  c_44_d: { title: '无形资产' },
  c_45_d: { title: '开发支出' },
  c_46_d: { title: '商誉' },
  c_47_d: { title: '长期待摊费用' },
  c_48_d: { title: '其他非流动资产' },
  c_49_d: { title: '递延所得税资产' },
  c_50_d: { title: '递延税款借项' },
  g_52_h: { title: '负债及所有者权益总计', bold: true, paddingLeft: '0px' },
  g_22_h: { title: '流动负债合计', bold: true, paddingLeft: '20px' },
  g_5_h: { title: '短期借款' },
  g_6_h: { title: '交易性金融负债' },
  g_7_h: { title: '应付票据' },
  g_8_h: { title: '应付账款' },
  g_9_h: { title: '预收账款' },
  g_10_h: { title: '应付职工薪酬' },
  g_11_h: { title: '应付工资' },
  g_12_h: { title: '应付福利费' },
  g_13_h: { title: '应交税费' },
  g_14_h: { title: '应付利息' },
  g_15_h: { title: '应付股利' },
  g_16_h: { title: '其他应交款' },
  g_17_h: { title: '其他应付款' },
  g_18_h: { title: '预提费用' },
  g_19_h: { title: '流动负债中的预计负债' },
  g_20_h: { title: '一年内到期的非流动负债' },
  g_21_h: { title: '其他流动负债' },
  g_32_h: { title: '非流动负债合计', bold: true, paddingLeft: '20px' },
  g_24_h: { title: '长期借款' },
  g_25_h: { title: '应付债券' },
  g_26_h: { title: '长期应付款' },
  g_27_h: { title: '专项应付款' },
  g_28_h: { title: '非流动负债中的预计负债' },
  g_29_h: { title: '递延所得税负债' },
  g_30_h: { title: '其他非流动负债' },
  g_31_h: { title: '递延税款贷项' },
  g_35_h: { title: '负债合计', bold: true, paddingLeft: '20px' },
  g_42_h: { title: '所有者权益合计', bold: true, paddingLeft: '20px' },
  g_37_h: { title: '股本' },
  g_38_h: { title: '资本公积' },
  g_39_h: { title: '盈余公积' },
  g_40_h: { title: '未分配利润' },
  g_41_h: { title: '外币报表折算差额' },
}

export const PROFIT_KEY_TITLE_OBJ = {
  b_4_c: { title: '营业收入' },
  b_5_c: { title: '营业成本' },
  b_6_c: { title: '营业税金及附加' },
  b_7_c: { title: '毛利' },
  b_8_c: { title: '其他业务利润' },
  b_9_c: { title: '销售费用' },
  b_10_c: { title: '管理费用' },
  b_11_c: { title: '财务费用' },
  b_12_c: { title: '其中：净非经营性利息费用' },
  b_13_c: { title: '非经营性利息收入' },
  b_14_c: { title: '资产减值损失－新准则使用' },
  b_15_c: { title: '公允值变动收益 －新准则使用' },
  b_16_c: { title: '投资收益－新准则使用' },
  b_17_c: { title: '营业利润' },
  b_18_c: { title: '投资收益－旧准则使用' },
  b_19_c: { title: '补贴收入' },
  b_20_c: { title: '营业外收入' },
  b_21_c: { title: '营业外支出' },
  b_22_c: { title: '利润总额' },
  b_23_c: { title: '所得税费用' },
  b_24_c: { title: '税后利润' },
  b_25_c: { title: '少数股东损益' },
  b_26_c: { title: '其他调整项目' },
  b_27_c: { title: '净利润' },
  b_28_c: { title: '期初未分配利润' },
  b_29_c: { title: '当期利润分配' },
  b_30_c: { title: '期末未分配利润' },
}

export const CASH_FLOW_KEY_TITLE_OBJ = {
  EMPTY_1: {
    title: '一、经营活动产生的现金流量',
    bold: true,
    noFormat: true,
    paddingLeft: '0px',
  },
  c_14: {
    title: '经营活动产生的现金流量净额',
    bold: true,
    paddingLeft: '20px',
  },
  c_8: { title: '现金流入小计', bold: true },
  c_5: { title: '销售商品、提供劳务收到的现金' },
  c_6: { title: '收到的税费返还' },
  c_7: { title: '收到的其他与经营活动有关的现金' },
  c_13: { title: '现金流出小计', bold: true },
  c_9: { title: '购买商品、接受劳务支付的现金' },
  c_10: { title: '支付给职工以及为职工支付的现金' },
  c_11: { title: '支付的各项税费' },
  c_12: { title: '支付的其他与经营活动有关的现金' },
  EMPTY_2: {
    title: '二、投资活动产生的现金流量',
    bold: true,
    noFormat: true,
    paddingLeft: '0px',
  },
  c_25: {
    title: '投资活动产生的现金流量净额',
    bold: true,
    paddingLeft: '20px',
  },
  c_20: { title: '现金流入小计', bold: true },
  c_16: { title: '收回投资所收到的现金' },
  c_17: { title: '取得投资收益所收到的现金' },
  c_18: { title: '处置固定资产、无形资产和其他长期资产所收回的现金净额' },
  c_19: { title: '收到的其他与投资活动有关的现金' },
  c_24: { title: '现金流出小计', bold: true },
  c_21: { title: '购建固定资产、无形资产和其他长期资产所支付的现金' },
  c_22: { title: '投资所支付的现金' },
  c_23: { title: '支付的其他与投资活动有关的现金' },
  c_26: { title: '三、筹资活动产生的现金流量', bold: true, paddingLeft: '0px' },
  c_35: {
    title: '筹资活动产生的现金流量净额',
    bold: true,
    paddingLeft: '20px',
  },
  c_30: { title: '现金流入小计', bold: true },
  c_27: { title: '吸收投资所收到的现金' },
  c_28: { title: '借款所收到的现金' },
  c_29: { title: '收到的其他与筹资活动有关的现金' },
  c_34: { title: '现金流出小计', bold: true },
  c_31: { title: '偿还债务所支付的现金' },
  c_32: { title: '分配股利、利润或偿付利息所支付的现金' },
  c_33: { title: '支付的其他与筹资活动有关的现金' },
  c_36: { title: '四、汇率变动对现金的影响', bold: true, paddingLeft: '0px' },
  c_37: {
    title: '五、现金及现金等价物净增加额',
    bold: true,
    paddingLeft: '0px',
  },
  EMPTY_3: {
    title: '补充资料',
    bold: true,
    noFormat: true,
    paddingLeft: '0px',
  },
  f_4: {
    title: '1、将净利润调节为经营活动现金流量',
    bold: true,
    paddingLeft: '0px',
  },
  f_21: {
    title: '经营活动产生的现金流量净额',
    bold: true,
    paddingLeft: '20px',
  },
  f_5: { title: '净利润' },
  f_6: { title: '加：计提的资产减值准备' },
  f_7: { title: '固定资产折旧' },
  f_8: { title: '无形资产摊销' },
  f_9: { title: '长期待摊费用摊销' },
  f_10: { title: '待摊费用减少（减：增加）' },
  f_11: { title: '预提费用增加（减：减少）' },
  f_12: {
    title: '处置固定资产、无形资产和其他长期资产的损失（减：收益）',
  },
  f_13: { title: '固定资产报废损失' },
  f_14: { title: '财务费用' },
  f_15: { title: '投资损失（减：收益）' },
  f_16: { title: '递延税款贷项（减：借项）' },
  f_17: { title: '存货的减少（减：增加）' },
  f_18: { title: '经营性应收项目的减少（减：增加）' },
  f_19: { title: '经营性应付项目的增加（减：减少）' },
  f_20: { title: '其他' },
  f_25: {
    title: '2、不涉及现金收支的投资和筹资活动',
    bold: true,
    paddingLeft: '0px',
  },
  f_26: { title: '债务转为资本' },
  f_27: { title: '一年内到期的可转换公司债券' },
  f_28: { title: '融资租入固定资产' },
  f_32: {
    title: '3、现金及现金等价物净增加情况',
    bold: true,
    paddingLeft: '0px',
  },
  f_37: { title: '现金及现金等价物净增加额', bold: true, paddingLeft: '20px' },
  f_33: { title: '现金的期末余额' },
  f_34: { title: '减：现金的期初余额' },
  f_35: { title: '加：现金等价物的期末余额' },
  f_36: { title: '减：现金等价物的期初余额' },
}
